import type { Translations } from "../types";

const fi: Translations = {
  "meta.title": "Klikit maittain -kartta",
  "meta.description":
    "Interaktiivinen maailmankartta: ilmaiset klikit maittain sekä maksullinen tuki Stripen, PayPalin ja Buy Me a Coffeen kautta.",

  "app.title": "Klikit maittain -kartta",

  "map.intro":
    "Klikkaa maata kartalla antaaksesi sille ilmaisen äänen, tai lähetä sille taloudellista tukea - molemmat lasketaan yhdistettyyn tulostaulukkoon alla. Kartta kuvaa vain tämän sovelluksen sisäistä tukea, ei maan todellista vaurautta tai BKT:ta.",
  "map.verifying": "Vahvistetaan …",
  "map.confirmNotRobot": "Ennen kuin voit lisätä ilmaisia klikkejä, vahvista nopeasti, ettet ole robotti:",
  "map.tryAgain": "Yritä uudelleen",
  "map.registeringClick": "Rekisteröidään klikkiä …",
  "map.selectedCountry": "Valittu maa: {name}.",
  "map.selectFirstFeedback": "Maa valittu. Lisätäksesi ilmaisen klikin, vahvista ensin alla, ettet ole robotti.",
  "map.verificationExpired": "Vahvistus on vanhentunut - vahvista uudelleen, ettet ole robotti.",
  "map.slowDown": "Vähän hitaammin - odota hetki ennen seuraavaa klikkiäsi.",
  "map.clickFailed": "Klikkiä ei voitu rekisteröidä. Yritä uudelleen.",
  "map.clickErrorGeneric": "Virhe klikin rekisteröinnissä.",
  "map.leaderboardHeading": "Maiden tulostaulukko",
  "map.emptySelection": "Valitse maa kartalta klikataksesi sitä tai tukeaksesi sitä.",
  "map.loadingData": "Ladataan tietoja …",

  "worldmap.loadError": "Karttaa ei voitu ladata.",
  "worldmap.resetZoom": "Nollaa zoomaus",
  "worldmap.resetButton": "⤾ Nollaa",
  "worldmap.loadingMap": "Ladataan karttaa …",
  "worldmap.unknownCountry": "Tuntematon",
  "worldmap.ariaClicks": "{name}: {clicks} klikkiä",
  "worldmap.tooltipClicks": "{clicks} klikkiä",

  "legend.fewer": "Vähemmän klikkejä",
  "legend.more": "Enemmän klikkejä",

  "list.empty": "Ei vielä klikkejä. Ole ensimmäinen!",
  "list.ariaLabel": "Maiden tulostaulukko klikkien mukaan",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY ei ole asetettu - katso README-tiedostosta ohjeet.",
  "human.verificationFailedGeneric": "Vahvistus epäonnistui.",
  "human.networkError":
    "Vahvistukseen ei saatu yhteyttä (verkkovirhe) - tarkista VITE_SUPABASE_URL, että verify-human on julkaistu, ja ALLOWED_ORIGIN; katso README/NAVODILA.",
  "human.verificationFailedRetry": "Vahvistus epäonnistui, yritä uudelleen.",

  "provider.stripe": "💳 Kortti (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Valittu maa",
  "panel.currentlyRanked": "Sijalla #{rank} tällä hetkellä",
  "panel.shareCopied": "Kopioitu ✓",
  "panel.shareShared": "Jaettu ✓",
  "panel.shareButton": "🔗 Jaa",

  "panel.tableClicks": "Klikit",
  "panel.tableFree": "Ilmaiset",
  "panel.tablePaid": "Maksetut",
  "panel.rowAllTime": "Kaikki ajat",
  "panel.rowThisYear": "Tänä vuonna",
  "panel.rowThisWeek": "Tällä viikolla",
  "panel.rowToday": "Tänään",

  "panel.totalCombined": "Yhteensä:",
  "panel.totalSupport": "Tuki yhteensä:",

  "panel.paymentMethod": "Maksutapa",
  "panel.noPaymentMethod": "Yhtään maksutapaa ei ole tällä hetkellä saatavilla.",
  "panel.supportAmount": "Tuen määrä (EUR)",
  "panel.amountRange": "Määrän tulee olla välillä {min}-{max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Arvioidut maksetut klikit:",
  "panel.ratioInfo":
    "Suhde: {a} = {b} klikkiä (esim. {c} = {d} klikkiä). Tämä on vain arvio ennen maksua - lopullisen klikkimäärän laskee ja vahvistaa aina palvelin todellisuudessa vahvistetun maksun perusteella.",
  "panel.preparing": "Valmistellaan …",
  "panel.continueWith": "Jatka palvelulla {provider}",
  "panel.choosePaymentMethod": "Valitse maksutapa",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME ei ole asetettu - katso README-tiedostosta ohjeet.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID ei ole asetettu - katso README-tiedostosta ohjeet.",

  "panel.paypalAmountInfo": "Summa: {amount} (arviolta {clicks} klikkiä). Viimeistele maksu alla olevalla PayPal-painikkeella.",
  "panel.back": "← Takaisin",

  "panel.bmcWarningTitle": "⚠️ Ennen kuin jatkat BuyMeCoffeehen:",
  "panel.bmcWarningBody":
    "Liitä alla oleva koodi kassalla viesti-/muistiinpanokenttään — se on ainoa tapa, jolla tiedämme, mitä maata tuet. Ilman koodia emme voi kohdistaa maksua mihinkään maahan.",
  "panel.copy": "Kopioi",
  "panel.copied": "Kopioitu ✓",
  "panel.suggestedAmount": "Ehdotettu summa:",
  "panel.bmcAmountNote":
    "(arviolta {clicks} klikkiä). BuyMeCoffee ei valitettavasti tue summan siirtämistä linkin kautta — syötä/valitse se itse heidän sivullaan. Todellinen klikkimäärä lasketaan aina summasta, jonka todella lähetät BuyMeCoffeessa, ei tästä arviosta.",
  "panel.openBmc": "Avaa BuyMeCoffee ja jatka →",
  "panel.waitingProvider": "Odotetaan maksun vahvistusta maksupalveluntarjoajalta …",
  "panel.waitingConfirmation": "Odotetaan maksun vahvistusta …",
  "panel.timedOut":
    "Tarkistus aikakatkaistiin. Jos suoritit maksun, kartta päivittyy, kun palvelin saa vahvistuksen - tämä voi joskus kestää hieman pidempään.",
  "panel.checkAgain": "Tarkista uudelleen",

  "panel.cancelled": "Maksu peruutettiin tai ei mennyt läpi. Kartta ei ole muuttunut.",
  "panel.tryAgain": "Yritä uudelleen",

  "panel.confirmed": "✅ Tuki vahvistettu!",
  "panel.confirmedBody": "{country} sai {clicks} maksettua klikkiä summalla {amount}.",

  "panel.errorPreparingSupport": "Virhe tukesi valmistelussa.",
  "panel.errorPreparingPayment": "Virhe maksun valmistelussa.",
  "panel.errorConfirmingPayment": "Virhe maksun vahvistamisessa.",
  "panel.errorPayingPaypal": "Virhe maksettaessa PayPalilla.",

  "share.unranked": "{flag}{country} tarvitsee tukesi maailmankartalla!\nAuta sitä nousemaan tulostaulukossa 👇",
  "share.rank1": "{flag}{country} on tällä hetkellä sijalla #1!\nAuta meitä pysymään kärjessä 👇",
  "share.rankN": "{flag}{country} on tällä hetkellä sijalla #{rank}!\nAuta meitä pääsemään sijalle #1 👇",

  "language.switcherLabel": "Kieli",
};

export default fi;
